import { render, staticRenderFns } from "./SupplierStockTemplateCountriesComponent.vue?vue&type=template&id=7845b326&"
import script from "./SupplierStockTemplateCountriesComponent.vue?vue&type=script&lang=js&"
export * from "./SupplierStockTemplateCountriesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports